import React from "react";
import { Spin } from "antd";
const Spinner = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        height: "100vh",
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin size={"100px"} />
    </div>
  );
};

export default Spinner;
